import { AssetType } from "../../../../utils/storage";
import Enum from "../../../../utils/types";

export const SERVICES_MENU_VARIANTS = {
    VARIANT_1: 'variant_1',
    VARIANT_2: 'variant_2',
    VARIANT_3: 'variant_3',
    VARIANT_4: 'variant_4',
    VARIANT_5: 'variant_5',
    VARIANT_6: 'variant_6',
} as const;

export type ServicesMenuVariant = Enum<typeof SERVICES_MENU_VARIANTS>;

export interface ChapterSectionQrCode {
    media: AssetType;
    logo?: AssetType;
    variant?: 'corner' | 'default';
    title: string;
    subtitle: string;
}

export interface HasQrSection {
    has_qr_code?: boolean;
    qr_code?: ChapterSectionQrCode;
}

export interface ChapterSection extends HasQrSection {
    id: string;
    expanded_title: string;
    title?: string;
    description?: string;
    variant: ServicesMenuVariant;
    media?: AssetType;
}

interface ServicesMenuChapter {
    subtitle: string;
    headline: string;
    is_show_date: boolean;
    sections: ChapterSection[];
}

export default ServicesMenuChapter;
